interface TeamNumberProps {
  value: number;
}

export default function TeamNumber({ value }: TeamNumberProps) {
  return (
    <span className="inline-flex items-center gap-[2px] mb-[4px]">
      <span className="flex items-center font-unibet font-medium text-[15px] leading-[9px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
        #
      </span>
      <span className="font-unibet font-medium text-[24px] leading-[24px] text-pmw-label-primary-light dark:text-pmw-label-primary-dark">
        {value}
      </span>
    </span>
  );
}
